import isPropValid from "@emotion/is-prop-valid";
import styled from "styled-components";
import boxMixin from "../../../mixins/box";
export const ContentContainer = styled.div.withConfig({
    shouldForwardProp: isPropValid,
}) `
  ${boxMixin};
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ29udGVudENvbnRhaW5lci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0JveC9zdHlsZWQvQ29udGVudENvbnRhaW5lci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLFdBQVcsTUFBTSx3QkFBd0IsQ0FBQztBQUNqRCxPQUFPLE1BQU0sTUFBTSxtQkFBbUIsQ0FBQztBQUN2QyxPQUFPLFFBQTJCLE1BQU0scUJBQXFCLENBQUM7QUFFOUQsTUFBTSxDQUFDLE1BQU0sZ0JBQWdCLEdBQUcsTUFBTSxDQUFDLEdBQUcsQ0FBQyxVQUFVLENBQUM7SUFDcEQsaUJBQWlCLEVBQUUsV0FBVztDQUMvQixDQUFDLENBQWU7SUFDYixRQUFRO0NBQ1gsQ0FBQyJ9